
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import { IModalComponent, FormButtonDisabler, Validations, Btn, Field, TextField, DateField } from '@samc/centricity-core';
  import { TransactionService } from '@/Services';
  import { IPackageMilestones } from '@/Interfaces';
  
  @Component({
    name: 'edit-milestone-modal',
    components: { FormButtonDisabler, Btn, Field, TextField, DateField }
  })
  export default class EditMilestoneModalComponent extends Vue implements IModalComponent {
    @Prop() public addCloseProp!: (callback: () => Promise<boolean | undefined>) => void;
    @Prop() public closeProp!: () => void;
    @Prop() public verificationToken!: string;
    @Prop({ required: true }) public milestoneId!: number;
    @Prop({ required: true }) public milestoneName!: string;
    @Prop({ required: true }) public packageId!: number;
    @Prop({ required: true }) public packageGuidId!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;

    public updateMilestone: IPackageMilestones = {
      milestoneName: '', asOfDate: '', milestoneId: 0, packageInternalId: 0
    };
    public loaded: boolean = false;
    public updateResult: boolean = false;
    public showValidations: boolean = false;
    public transactionService: TransactionService | null = null;
    public foundMilestone: IPackageMilestones | null = null;

    public get validations(): Validations<{ name: string, date: string }> {
      let result: Validations<{ name: string, date: string }> = {}
      if (this.updateMilestone.milestoneName.trim().length == 0) {
        result.name = 'Milestone Name is required!';
      }
      if (this.updateMilestone.asOfDate == '') {
        result.date = 'As of Date is required!';
      }
      return result;
    }



    public async mounted() {
      this.verificationToken ??= await this.$verificationToken();
      this.transactionService = new TransactionService(this.verificationToken);
      try {
        if (this.milestoneId == 0) { //default name, not added by user
          this.updateMilestone.milestoneName = this.milestoneName;
          this.updateMilestone.asOfDate = '';
          this.updateMilestone.milestoneId = 0;
          this.updateMilestone.packageInternalId = this.packageId;
        }
        else {
          const response = await this.transactionService?.getMilestone(this.milestoneId);
          if (!response) {
            this.$alert.error('An error occurred during getting milestone info.');
            return;
          }
          this.updateMilestone.milestoneName = response.milestoneName;
          this.updateMilestone.asOfDate = response.asOfDate;
          this.updateMilestone.milestoneId = response.milestoneId;
          this.updateMilestone.packageInternalId = this.packageId;
        }
        this.loaded = true;
      }
      catch (err: any) {
        this.$alert.error('An error occurred getting milestone info.');
        console.log(err);
      }

      this.addCloseProp(async () => {
        this.showValidations = true;

        if (Object.keys(this.validations).length === 0) {
          await this.updateChanges();
          return this.updateResult;
        }
      });
    }

    public dateWithoutTimezone (date: Date) {
      const tzoffset = date.getTimezoneOffset() * 60000; //offset in milliseconds
      const withoutTimezone = new Date(date.valueOf() - tzoffset)
        .toISOString()
        .slice(0, -1);
      return withoutTimezone;
    };


    public async updateChanges() {
      this.$loading('Updating milestone');
      try {
        this.updateMilestone.milestoneName = this.updateMilestone.milestoneName.trim();
        const res=await this.checkNames(this.updateMilestone.milestoneName);

        if (!res) {
          return;
        }
        const asOfDateObject: Date = new Date(this.updateMilestone.asOfDate);
        const date2 = this.dateWithoutTimezone(asOfDateObject);
        this.updateMilestone.asOfDate = date2; 

        const response = await this.transactionService?.updateMilestone(this.updateMilestone);
        if (!response) {
          this.$alert.error('An error occurred during updating milestone.');
          return;
        }
        this.updateResult = true;

      }
      catch (err: any) {
        this.$alert.error('An error occurred during updating milestone.');
        console.log(err);
      }
      finally {
        this.$loading();
      }
    }


    public async checkNames(name: string) {
      const response = await this.transactionService?.getMilestonebyName(this.packageGuidId, this.milestoneId, name);

      if (!response) {
        this.$alert.error('An error occurred during milestone name check.');
        return false;
      }

      if (response.milestoneName !== null) {
        this.$alert.error(`This milestone name (${name}) already exists.`);
        return false;
      }
      return true;
    }

  }

